import React, { useState, useContext } from "react";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { IconButton, Stack, Box, Tooltip, Switch, Dialog, DialogTitle, DialogContent, Grid, Typography, Button } from "@mui/material";
import { useMutation } from "@apollo/client";
import { BiMinusCircle } from "react-icons/bi";
import { IoMdSend } from "react-icons/io";
//Import from project
import "../../Style/actionstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { UPDATE_TOPAY_NOTIFICATION_STATUS, RESEND_TOPAY_NOTIFICATION } from "../../Schema/ToPayInvoice"
import DeleteToPayNotification from "./DeleteToPayNotification";

export default function PaidInvoiceAction({ editData, setRefetch }) {
  const { setAlert } = useContext(AuthContext)
  const [loading, setLoading] = useState(false)

  //Modal update
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  //Modal resent
  const [openResend, setOpenResend] = useState(false);
  const handleOpenResend = () => setOpenResend(true);
  const handleCloseResend = () => setOpenResend(false);

  const [updateToPayNotificationStatus] = useMutation(
    UPDATE_TOPAY_NOTIFICATION_STATUS,
    {
      onCompleted: ({ updateToPayNotificationStatus }) => {
        // console.log("updateToPayNotificationStatus::", updateToPayNotificationStatus)
        if (updateToPayNotificationStatus?.status) {
          setAlert(true, "success", updateToPayNotificationStatus?.message);
          setRefetch();
          handleClose()
        } else {
          setAlert(true, "error", updateToPayNotificationStatus?.message);
        }
      },
      onError: (error) => {
        console.log(error);
      },
    }
  );

  const handleChangeStatus = (checked) => {
    // setChecked(e.target.checked);
    updateToPayNotificationStatus({
      variables: {
        id: editData?._id,
        isShowMobileApp: checked,
      },
    });
  };

  // ==================================== Mutation Resend notification ===================================
  const [resendToPayInvoiceNotification] = useMutation(RESEND_TOPAY_NOTIFICATION, {
    onCompleted: ({ resendToPayInvoiceNotification }) => {
      setLoading(false);
      // console.log("resendToPayInvoiceNotification::", resendToPayInvoiceNotification);
      if (resendToPayInvoiceNotification?.status === true) {
        setAlert(true, "success", resendToPayInvoiceNotification?.message);
        handleCloseResend();
        setRefetch();
      } else {
        setAlert(true, "error", resendToPayInvoiceNotification?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });


  const handleResendNotification = () => {
    setLoading(true)
    resendToPayInvoiceNotification({
      variables: {
        id: editData?._id,
      }
    })
  }

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title="update status" placement="top">
          <IconButton onClick={handleOpen}>
            <Box className="update-container">
              <MdModeEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        <Tooltip title="delete notification" placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        <Tooltip title="Resend notification" placement="top">
          <IconButton onClick={handleOpenResend}>
            <Box className="save-container">
              <IoMdSend className="save-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      <Dialog open={open} className="dialog-container" fullWidth maxWidth="xs">
        <DialogTitle sx={{ padding: "10px 20px" }}>
          <Stack direction="row" spacing={2}>
            <Stack direction="column" justifyContent="center">
              <Typography className="dialog-title">Change To Pay Notification Status</Typography>
            </Stack>
            <Box sx={{ flexGrow: 1 }} />
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography>
                Do you really want to change status this data!
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Stack direction="row" justifyContent="center">
                <Tooltip title="Change status">
                  <Switch
                    checked={editData?.isShowMobileApp}
                    onClick={() => handleChangeStatus(editData?.isShowMobileApp ? false : true)}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Tooltip>
              </Stack>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <Dialog open={openResend} className="dialog-container" fullWidth maxWidth="sm">
        <DialogTitle sx={{ padding: "10px 20px" }}>
          <Stack direction="row" spacing={2}>
            <Stack direction="column" justifyContent="center">
              <Typography className="dialog-title">Resend To Pay Notification</Typography>
            </Stack>
            <Box sx={{ flexGrow: 1 }} />
            <IconButton onClick={handleCloseResend}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography>
                Do you really want to resend this notification!
              </Typography>
            </Grid>
            <Grid item xs={12}>
              {loading ? (
                <Button className="btn-create" fullWidth>
                  Loading...
                </Button>
              ) : (
                <Button
                  className="btn-create"
                  fullWidth
                  onClick={handleResendNotification}
                >
                  Resent
                </Button>
              )}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <DeleteToPayNotification
        open={openDel}
        editData={editData}
        setRefetch={setRefetch}
        handleClose={handleCloseDel}
      />
    </div>
  );
}
